/**
 * Pre-generated HS256 JWT for the debugger's default state.
 *
 * Header:  { "alg": "HS256", "typ": "JWT" }
 * Payload: {
 *   "sub": "user_01H",
 *   "iss": "https://api.workos.com",
 *   "iat": 1700000000,
 *   "exp": 1700003600,
 *   "email": "test@example.com",
 *   "org_id": "org_01H",
 *   "role": "admin",
 *   "permissions": ["read", "write"]
 * }
 *
 * Signed with HMAC-SHA256 using EXAMPLE_SECRET.
 */
export const EXAMPLE_JWT =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ1c2VyXzAxSCIsImlzcyI6Imh0dHBzOi8vYXBpLndvcmtvcy5jb20iLCJpYXQiOjE3MDAwMDAwMDAsImV4cCI6MTcwMDAwMzYwMCwiZW1haWwiOiJ0ZXN0QGV4YW1wbGUuY29tIiwib3JnX2lkIjoib3JnXzAxSCIsInJvbGUiOiJhZG1pbiIsInBlcm1pc3Npb25zIjpbInJlYWQiLCJ3cml0ZSJdfQ.UwQrDbWuuxqreniNgk9SalMV_D5ujSDnDgsbeU0gm0o';

export const EXAMPLE_SECRET = 'workos-jwt-debugger-example';
